<template>
	<svg class="ls-icon ls-icon-dashes" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
		<!-- Icon from Huge Icons by Hugeicons - undefined -->
		<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 12h2.5m-8 0H16m-8 0h2.5m-8 0H5" />
	</svg>
</template>
